module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":"The sensor settings are in read-only mode. To modify the settings, please visit"},"it":{"message":"Le impostazioni per il sensore sono in modalità di sola lettura. Per modificare le impostazioni visita"}}')
  delete Component.options._Ctor
}
